import { useState, useCallback } from "react";

const parsedMaxVideos = Number(import.meta.env.VITE_MAX_VIDEOS_PER_REPORT);
export const MAX_VIDEOS_PER_REPORT =
  Number.isFinite(parsedMaxVideos) && parsedMaxVideos > 0 ? parsedMaxVideos : 40;

export const useVideoSelection = () => {
  const [selectedVideos, setSelectedVideos] = useState<string[]>([]);

  const handleVideoSelection = useCallback(
    (videoId: string, isSelected: boolean) => {
      if (isSelected) {
        if (selectedVideos.length >= MAX_VIDEOS_PER_REPORT) {
          return;
        }
        setSelectedVideos((prev) => [...prev, videoId]);
      } else {
        setSelectedVideos((prev) => prev.filter((id) => id !== videoId));
      }
    },
    [selectedVideos.length]
  );
  
  const handleRemoveVideo = useCallback((videoId: string) => {
     setSelectedVideos((prev) => prev.filter((id) => id !== videoId));
  }, []);

  const clearSelection = useCallback(() => {
    setSelectedVideos([]);
  }, []);

  return {
    selectedVideos,
    handleVideoSelection,
    handleRemoveVideo,
    clearSelection,
  };
};
